<fgb-auction-bid-list></fgb-auction-bid-list>
